import { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from './constants';

const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfile(session.user.id);
      else setLoading(false);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
      if (session?.user) fetchProfile(session.user.id);
      else { setProfile(null); setLoading(false); }
    });

    return () => subscription.unsubscribe();
  }, []);

  const fetchProfile = async (userId) => {
    const { data } = await supabase.from('profiles').select('*').eq('id', userId).single();
    setProfile(data);
    setLoading(false);
  };

  const signUp = async (email, password, fullName, role = 'fellow') => {
    const { data, error } = await supabase.auth.signUp({ email, password });
    if (error) return { error };
    if (data?.user) {
      await supabase.from('profiles').insert([{
        id: data.user.id, email, full_name: fullName, role,
      }]);
    }
    return { data };
  };

  const signIn = async (email, password) => {
    return await supabase.auth.signInWithPassword({ email, password });
  };

  const signOut = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setProfile(null);
    setLoading(false);
  };

  const isDirector = profile?.role === 'director';
  const isChairman = profile?.role === 'chairman';

  return (
    <AuthContext.Provider value={{ user, profile, loading, signUp, signIn, signOut, isDirector, isChairman, fetchProfile }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
